import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PatchMemberBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Mutation hook for updating a member's contact information. Invalidates the member query on success. */
export function useUpdateMember(memberId: string) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PatchMemberBody) => {
      const response = await api.patch('/members/:memberId', { params: { memberId }, body })
      if (!response.success) throw new Error(response.error.message)
      return response.data.member
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['member', memberId] })
    },
  })
}
